<template>
  <div id="page">

    <h1>NPC</h1>

    <p>Under construction</p>
  </div>
</template>

<script>
export default {
    name: "NPC",
    components: { },
    mounted() {

    },
    methods: {
      
    }
}
</script>

<style lang="scss" scoped>

</style>
